import { type Context, useContext } from 'react';

import { fragmentContext } from './fragmentContext';

export function useFragmentContext<T = {}>(): T {
    return useContext<T>(fragmentContext as Context<T>);
}
